import React, { forwardRef, useEffect, useState } from 'react';
import clsx from 'clsx';
import { Dropdown } from '../dropdown';
import * as styles from './tooltip.styles';

/** @type {import(".").TooltipType} */
const Tooltip = forwardRef(
  ({ className, children, content, show, align = 'center', position = 'auto-top', as = 'span', beakDistance, style, ...props }, ref) => {
    const [state, setState] = useState(show);
    useEffect(() => {
      setState(show);
    }, [show]);

    // to be able to attach listener we wrap the children on a span if its a string or more than one element
    const child =
      typeof children === 'string' || typeof children === 'number' || React.Children.count(children) > 1 ? <span>{children}</span> : children;

    // if the show prop its set this will be a controlled component, so we do not attach the listeners
    const listener =
      show !== undefined
        ? {}
        : {
            onMouseEnter: () => {
              setState(true);
            },
            onMouseLeave: () => {
              setState(false);
            },
          };

    return (
      <Dropdown align={align} position={position} as={as} ref={ref} open={state} className={styles.tooltip} {...listener}>
        <Dropdown.Trigger>{child}</Dropdown.Trigger>
        <Dropdown.Content
          as="div"
          className={clsx(styles.components.content, className)}
          style={{
            ...style,
            ...(beakDistance !== undefined && {
              '--tooltip-beak-margin': `${beakDistance}px`,
            }),
          }}
          {...props}
        >
          {content}
        </Dropdown.Content>
      </Dropdown>
    );
  },
);

if (process.env.NODE_ENV !== 'production') {
  Tooltip.displayName = 'Tooltip';
}

export default Tooltip;
